import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import * as authHelper from './authHelpers'
import { AuthModel, UserWithRole, WithChildren } from 'components/types'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'
import axios from 'axios'
import { getUser } from 'api/calls'
import { Corporate, StartUp, User, initalStartUp } from 'components/types/types'
import { LoginType } from 'components/types/Context'
import { AUTH_LOCAL_STORAGE_KEY } from './authHelpers'
import { initialPager, initialReqCorporate } from 'components/types/InitialData'
import { useGuestView } from 'shared/GeneralContext/GuestContext'

type AuthContextProps = {
  auth: AuthModel | null
  saveAuth: (auth: AuthModel | null) => void
  currentUser: UserWithRole | undefined
  setCurrentUser: Dispatch<SetStateAction<UserWithRole | undefined>>
  logout: () => void
}

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => { },
  currentUser: undefined,
  setCurrentUser: () => { },
  logout: () => { },
}

export const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({ children }) => {
  const [auth, setAuth] = useState<AuthModel | null>(authHelper.getAuth())
  const [currentUser, setCurrentUser] = useState<UserWithRole | undefined>()
  const { setUser,
    setStartUp,
    setLoginType,
    setChatIsOpen,
    setModalDatesIsOpen,
    setCorporatesList,
    setStartupsList,
    setCities,
    setSectors,
    setTags,
    setstartUpIdforMatch,
    setReqCorporate,
    setPagerCorporatesList
  } = useContext(AppGeneralContext)
  const { resetGuest } = useGuestView()
  const saveAuth = (auth: AuthModel | null) => {
    

    setAuth(auth)
    if (auth) {
      authHelper.setAuth(auth)
    } else {
      authHelper.removeAuth()
    }
  }
  useEffect(() => {
    

  }, [auth])


  const logout = () => {
    delete axios.defaults.headers.common["Authorization"]
    setUser(undefined)
    setReqCorporate(initialReqCorporate)
    setPagerCorporatesList(initialPager)
    setCorporatesList([])
    setStartupsList([])
    setStartUp(initalStartUp)
    saveAuth(null)
    setCurrentUser(undefined)
    setLoginType(undefined)
    setChatIsOpen(false)
    setModalDatesIsOpen(false);
    setCities(undefined);
    setSectors(undefined);
    setTags(undefined);
    resetGuest();
    localStorage.clear()
  }

  return (
    <AuthContext.Provider value={{ auth, saveAuth, currentUser, setCurrentUser, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

const AuthInit: FC<WithChildren> = ({ children }) => {

  const {
    setNumberMatchRequest,
    setUser,
    setLoginType,
    setStartUp,
    setCorporate
  } = useContext(AppGeneralContext)
  const { auth, logout, setCurrentUser } = useAuth()

  const didRequest = useRef(false)
  // const [showSplashScreen, setShowSplashScreen] = useState(true)

  useEffect(() => {
    const requestUser = async (apiToken: string) => {
      // setLoadingModal()

      try {
        if (!didRequest.current) {
          const { isSuccess, response } = await getUser()

          if (response) {
            setCurrentUser(response as UserWithRole)

            const user = { ...response.user as User, role: response.role }
            setUser(user)

            const whoLogsIn = auth?.isStartUp ? LoginType.startup : LoginType.corporate

            setLoginType(whoLogsIn)


            if (whoLogsIn === LoginType.startup) {
              setStartUp(response.role as StartUp)
              let role = response.role as StartUp
              setNumberMatchRequest(role.currentCounter.availableMonthMatches)
            }

            if (whoLogsIn === LoginType.corporate) {
              setCorporate(response.role as Corporate)
            }
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          logout()
        }
      }

      return () => (didRequest.current = true)
    }

    if (auth && auth.jwtToken) {
      // setCorporatesList([])
      // setStartupsList([])
      // setReqCorporate(initialReqCorporate)
      // setPagerCorporatesList(initialPager)
      requestUser(auth.jwtToken)
    } else {
      logout()
    }
  }, [])

  return <>
    {children}
  </>
}

export { AuthProvider, AuthInit, useAuth }
